const columnAlignment = ["left", "center", "right"];

export { columnAlignment };
//# sourceMappingURL=column-alignment.mjs.map
